import OrderPlaced from ".";
const OrderPlacedRoutes = {
  routes: [
    {
      path: "/success",
      component: OrderPlaced,
      exact: true,
    },
  ],
};
export default OrderPlacedRoutes;
